var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreationCard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16,
    fill: "#EC4899"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.549 11.5862C25.6155 11.7466 25.65 11.9219 25.6501 12.0993V14.5001C25.6501 14.5001 25.6501 15.154 24.75 15.5001C23.8499 15.8462 23.5501 15.9635 23.5501 15.9635L20.6501 16.8836V26.7C20.6501 28.0261 19.2399 29.1001 17.5001 29.1001C15.7602 29.1001 14.3501 28.0261 14.3501 26.7C14.3501 25.374 15.7602 24.2999 17.5001 24.2999C17.8535 24.2991 18.2059 24.345 18.5501 24.4367V13.4995C18.5502 13.2222 18.6344 12.9535 18.7883 12.7391C18.9422 12.5247 19.1564 12.3778 19.3943 12.3235L24.3943 10.9233C24.5466 10.8885 24.7037 10.8928 24.8544 10.9357C25.005 10.9787 25.1455 11.0594 25.2656 11.1718C25.3857 11.2843 25.4825 11.4259 25.549 11.5862Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationCard3);
export default __webpack_public_path__ + "static/media/creation-card-3.5a60451d180fa9a7a2b09b9afabff69d.svg";
export { ForwardRef as ReactComponent };